var Devices = {
  getDeviceAttrs : function() {
    var device = {
      orientation : 'L',
      type : 'mobile',
      sizeKey : 'xs',
    };

    if ( $(window).width() < $(window).height() ) {
      device.orientation = 'P';
    }

    if ( $(window).width() >= 600 ) {
      device.sizeKey = 'sm';

      if ( device.orientation === 'L' ) {
        device.type = 'mobile';
      }
    }

    if ( $(window).width() >= 768 ) {
      device.sizeKey = 'md';

      if ( device.orientation === 'P' ) {
        device.type = 'tablet';
      }
    }

    if ( $(window).width() >= 960 ) {
      device.sizeKey = 'lg';
      device.type = 'tablet';
    }

    if ( $(window).width() >= 1140 ) {
      device.sizeKey = 'xl';
      device.type = 'desktop';
    }

    return device;
  },
};